<template>
  <div>
    <h2 class="text-2xl font-bold mb-4">📊 Reporte de Ventas</h2>

    <div class="flex items-center gap-4 mb-4">
      <label>Desde:</label>
      <input type="date" v-model="desde" class="border p-2 rounded" />
      <label>Hasta:</label>
      <input type="date" v-model="hasta" class="border p-2 rounded" />
      <button
        @click="cargarVentas"
        class="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Buscar
      </button>
    </div>

    <div v-if="ventas.length">
      <table class="w-full table-auto border text-sm">
        <thead class="bg-gray-200">
          <tr>
            <th class="p-2 border">Fecha</th>
            <th class="p-2 border">Método de Pago</th>
            <th class="p-2 border">Subtotal</th>
            <th class="p-2 border">Impuestos</th>
            <th class="p-2 border">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="venta in ventas" :key="venta.id">
            <td class="p-2 border">{{ formatearFecha(venta.fecha) }}</td>
            <td class="p-2 border">{{ venta.metodoPago }}</td>
            <td class="p-2 border">${{ venta.subtotal.toFixed(2) }}</td>
            <td class="p-2 border">${{ venta.impuestos.toFixed(2) }}</td>
            <td class="p-2 border font-bold">${{ venta.total.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="mt-6 space-y-1 text-sm">
        <div><strong>Total ventas:</strong> ${{ totalVentas.toFixed(2) }}</div>
        <div><strong>Efectivo:</strong> ${{ totalEfectivo.toFixed(2) }}</div>
        <div><strong>Tarjeta:</strong> ${{ totalTarjeta.toFixed(2) }}</div>
      </div>
    </div>

    <div v-else class="text-gray-500 mt-6">
      No hay ventas en este rango de fechas.
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { db } from "@/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from "firebase/firestore";

const desde = ref("");
const hasta = ref("");
const ventas = ref([]);

const totalVentas = ref(0);
const totalEfectivo = ref(0);
const totalTarjeta = ref(0);


const formatearFecha = (ts) => ts.toDate().toLocaleDateString();

const cargarVentas = async () => {
  if (!desde.value || !hasta.value) return alert("Selecciona fechas");

  const desdeTS = Timestamp.fromDate(new Date(desde.value + "T00:00:00"));
  const hastaTS = Timestamp.fromDate(new Date(hasta.value + "T23:59:59"));

  const q = query(
    collection(db, "ventas"),
    where("fecha", ">=", desdeTS),
    where("fecha", "<=", hastaTS)
  );

  const snap = await getDocs(q);

  // Reset
  ventas.value = [];
  totalVentas.value = 0;
  totalEfectivo.value = 0;
  totalTarjeta.value = 0;

  snap.forEach((doc) => {
    const data = doc.data();
    const metodo = (data.metodoPago || "").toLowerCase().trim();
    const subtotal = Number(data.subtotal || 0);
    let impuestos = Number(data.impuestos || 0);

    if (impuestos > subtotal) impuestos = 0; // Evita errores
    const total = subtotal + impuestos;

    // Acumular totales
    totalVentas.value += total;
    if (metodo === "efectivo") totalEfectivo.value += total;
    else totalTarjeta.value += total;

    ventas.value.push({
      id: doc.id,
      fecha: data.fecha,
      metodoPago: metodo,
      subtotal,
      impuestos,
      total,
    });
  });
};
</script>
